<template>
    <div class="event__list_select_update_table">
        <component-table
            :labels="[
                {
                    key: 'name',
                    title: 'Name',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'numberOfSessions',
                    title: 'Sessions',
                    type: 'number',
                    sortable: false,
                    queryable: false
                },
                {
                    key: 'nextSessionDate',
                    title: 'Next session',
                    type: 'date',
                    sortable: false,
                    queryable: false
                },
                {
                    key: 'courses',
                    title: 'Courses',
                    type: 'date',
                    sortable: false,
                    queryable: false
                },
                {
                    key: 'status',
                    title: 'Status',
                    type: 'string',
                    sortable: true,
                    queryable: true
                },
                {
                    key: 'actions',
                    title: '',
                    type: '',
                    sortable: false
                }
            ]"
            :items="items"
            :component-table-item="EventListSelectUpdateTableItem"
            @emit-selected="selectItem"
        />
        <div class="container">
            <div class="event__list_select_update_table_actions">
                <div class="columns">
                    <div class="column"></div>
                    <div class="column is-narrow">
                        <component-button
                            :theme="'default'"
                            :border="true"
                            :to="{ name: 'ebs-event-list' }"
                            :name="'event-list-select-update-table-actions-cancel'"
                        >{{ $t('ebs.events.list.buttons.buttonCancel') }}
                        </component-button>
                    </div>
                    <template v-if="selected">
                        <div class="column is-narrow">
                            <component-button
                                :animate-loading="true"
                                @click="updateSelectedEvent"
                                :name="'event-list-select-update-table-actions-select'"
                            >{{ $t('ebs.events.list.buttons.addSelectEvent') }}
                            </component-button>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventListSelectUpdateTableItem from '@/components/ebs/events/list/EventListSelectUpdateTableItem'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentTable from '@/components/default/shared/ComponentTable'

export default {
  name: 'event-list-select-update-table',
  components: {
    ComponentTable,
    ComponentButton
  },
  data () {
    return {
      selected: '',
      EventListSelectUpdateTableItem
    }
  },
  props: {
    items: {
      type: [Array, Object]
    }
  },
  methods: {
    selectItem: function (data) {
      this.selected = data
      this.$eventBus.$emit('event-list-select-update-unselect')
    },
    updateSelectedEvent: function () {
      const courseId = this.$route.params.courseId
      const eventId = this.selected
      this.$store.dispatch('updateEventAssignCourse', { courseId: courseId, eventId: eventId })
    }
  },
  watch: {
    items () {
      this.selected = ''
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/events/eventlistselectupdatetable";
</style>
